module.exports = __webpack_public_path__ + "img/maropost-form-logo.979d5c4c.svg";